export const HELP_CATEGORIES = [
  {
    title: "Getting Started",
    description: "Learn the basics and set up your account",
    articles: [
      "Getting Started with Zom",
      "Setting up Your First Account",
      "Navigation Guide",
      "Basic Features Overview",
    ],
  },
  {
    title: "Account Settings",
    description: "Manage your preferences and configuration",
    articles: [
      "Account Preferences",
      "Notification Settings",
      "Security Settings",
      "Profile Management",
    ],
  },
  {
    title: "Security & Privacy",
    description: "Understand our security practices",
    articles: [
      "Security Overview",
      "Privacy Policy",
      "Data Protection",
      "Authentication",
    ],
  },
  {
    title: "Features & Tools",
    description: "Explore Zom AI capabilities",
    articles: [
      "AI Chat Features",
      "Portfolio Management",
      "Client Management",
      "Analytics & Reports",
    ],
  },
] as const;

export const QUICK_LINKS = [
  { title: "Security Page", href: "/security" },
  { title: "Privacy Policy", href: "/privacy" },
  { title: "Terms of Service", href: "/terms" },
  { title: "Contact Support", href: "#report" },
] as const;

export const SUPPORT_TYPES = [
  {
    title: "Report a Technical Issue",
    description:
      "Experiencing bugs, errors, or technical problems? Let us know.",
  },
  {
    title: "Ask a Product Question",
    description: "Need help understanding a feature or completing a workflow?",
  },
  {
    title: "Submit a Security Concern",
    description:
      "Found a security vulnerability or have privacy concerns? Report it securely.",
  },
] as const;

export const SUPPORT_BADGES = [
  "24/7 Support",
  "Anonymous Reports",
  "Secure & Private",
  "Quick Response",
] as const;
